import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import type { MenuItem, Category } from '@/types/common';
import MenuItems from '@/components/Menu/MenuItems';
import { useIsAdmin } from '@/hooks/useIsAdmin';
import { useMenuData } from '@/hooks/useMenuData';
import React from 'react';

export default function MenuPage() {
  const { isLoading: isAuthLoading } = useAuth();
  const {
    menuItems,
    categories,
    subcategories,
    loading,
    createItem,
    updateItem,
    deleteItem,
    toggleItemAvailability
  } = useMenuData(isAuthLoading);

  const handleItemClick = async (item: MenuItem) => {
    await toggleItemAvailability(item);
  };

  // Show loading spinner while auth or data is loading
  if (isAuthLoading || loading) {
    return (
      <div className="flex items-center justify-center min-h-screen-75">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-600" />
      </div>
    );
  }

  return (
    <div className="space-y-6 container mx-auto px-4 pt-4">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-dark-text-primary">
          Menu Management
        </h1>
        <div className="mt-2 flex justify-between items-center">
          <p className="text-sm text-gray-700 dark:text-dark-text-secondary">
            View and manage menu items
          </p>
        </div>
      </div>

      {/* Menu Items List or Empty State */}
      {menuItems.length > 0 ? (
        <div>
          {/* MenuItems Component */}
          <MenuItems
            items={menuItems}
            categories={categories}
            subcategories={subcategories}
            onItemClick={handleItemClick}
            actionLabel="Edit"
            onCreateItem={createItem}
            onUpdateItem={updateItem}
            onDeleteItem={deleteItem}
            editable={true}
          />
        </div>
      ) : (
        <div className="text-center py-12 bg-white dark:bg-dark-surface rounded-lg shadow">
          <i className="fas fa-utensils text-4xl text-gray-400 dark:text-dark-text-secondary mb-4" />
          <h3 className="text-lg font-medium text-gray-900 dark:text-dark-text-primary mb-2">
            No menu items found
          </h3>
          <p className="text-gray-500 dark:text-dark-text-secondary">
            Start by adding some items to your menu.
          </p>
        </div>
      )}

      {/* Category Filters */}
      <div className="overflow-x-auto hide-scrollbar">
        {/* Your category filters */}
      </div>
    </div>
  );
}